import React from "react";
import SEO from "../components/SEO";
import Header from "../partials/header/Header";
import Breadcrumb from "../container/Breadcrumb/Breadcrumb";
// import HomeAbout from '../components/About/HomeAbout.jsx';

// import AboutFive from '../container/About/AboutFive';
// import TestimonialContainer from '../container/Testimonial/TestimonialContainer';
import Footer from "../container/Footer/Footer";
import ScrollToTop from "../components/ScrollToTop.jsx";
import EmptyTwo from "../container/Empty/EmptyTwo";
// import { Link } from "react-router-dom";
// import ProgramTable from '../container/Program/ProgramTable'
// import NewGif from "../components/Gif/NewGif";

// import EmptyOne from '../container/Empty/EmptyOne';

const Program = () => {
  const show = false;
  if (show) {
    return (
      <React.Fragment>
        <SEO title="Program | DMBD 2026" />
        <Header />
        <Breadcrumb
          image="images/bg/banner2-opt.jpg"
          title="Program"
          content="The Conference"
          contentTwo="Program"
          linkage="/"
        />

        {/* <HomeAbout /> */}
        <EmptyTwo>
          <h2>DMBD&apos;2024 Program Schedule(UTC+8)</h2>

          <div className="space-60"></div>

          {/* December 13: 13:00-18:00:  Registration (Hall A)
          <hr></hr>
          December 14: 09:00-18:00:  Online Parallel Sessions (Meeting Zoom No.)

          <hr></hr>
          December 15: 
          <br></br>
          &emsp;&emsp;&emsp;&emsp;&emsp;        09:00-12:00:  Opening Ceremony, Plenary talks (Multi-function Hall)<br></br>
          
          &emsp;&emsp;&emsp;&emsp;&emsp;         12:00-13:00:  Lunch (Cafe Hall)<br></br>
          &emsp;&emsp;&emsp;&emsp;&emsp;            13:00-18:00:  <br></br>
          &emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;   Parallel Sessions (Meeting Room 1#)<br></br>
          &emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;                          Parallel Sessions (Meeting Room 2#)<br></br>
          &emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;                          Special Sessions  (Meeting Room 3#)<br></br>
          &emsp;&emsp;&emsp;&emsp;&emsp;            18:30- :   <br></br>
          &emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;   Banquet & Award Ceremoney (Multi-function Hall)
          <hr></hr>
          December 16: Social Activities after technical sessions
          <hr></hr> */}
          <img src="./images/program/program_schedule_program_schedule.png" width="90%"></img>
          <img src="./images/program/technical program overview_Sheet1.png" width="90%"></img>
          <hr></hr>
          <div className="main-table"><div className="title-center"><h4>Day I &nbsp;&nbsp;&nbsp;Dec. 14th</h4></div>
<table className="sessions">
<tr> <th> Session Time </th><th>Boardroom(10th floor)</th>
<th>Online Room 1</th>
<th>Online Room 2</th>
<th>Online Room 3</th>
 </tr><tr> <th>10:00-10:20</th> <td>  </td>
<td> <p className="table-id"> No. #2417</p>
 <p className="table-title">Data-Driven Open Finance: A Novel Architecture for Financial Inclusion in Developing Countries</p>
 <p className="table-authors">Metouole Mwinbe Yves Ghislain Somda, Tahar Attoumane, Samuel Ouya and Gervais Mendy</p></td>
<td> <p className="table-id"> No. #696</p>
 <p className="table-title">Enhanced Image Captioning Model Using Winograd Convolution and Multi-objective Bayesian Optimization</p>
 <p className="table-authors">Meiling Xu, Yaguo Dong and Keda Pan</p></td>
<td> <p className="table-id"> No. #9786</p>
 <p className="table-title">Adaptive Dynamic Multi-Objective Trajectory Optimization for UAV-enabled Wireless Powered Communication Networks</p>
 <p className="table-authors">Miaomiao Jiang, Bei Dong, Lei Ming and Xiaojun Wu</p></td>
</tr><tr> <th>10:20-10:40</th> <td>  </td>
<td> <p className="table-id"> No. #7898</p>
 <p className="table-title">Three-way Clustering Based on Improved DPC Algorithm</p>
 <p className="table-authors">Yiping Meng, Lijun Fan and Pingxin Wang</p></td>
<td> <p className="table-id"> No. #3827</p>
 <p className="table-title">Controlled Causal Hallucinations Can Estimate Phantom Nodes in Multiexpert Mixtures of Fuzzy Cognitive Maps</p>
 <p className="table-authors">Akash Panda and Bart Kosko</p></td>
<td> <p className="table-id"> No. #1874</p>
 <p className="table-title">Meta-Analysis of Correlations between Software Engineering Metrics -- The case of Java</p>
 <p className="table-authors">Zamira Kholmatova, Mikhail Rudakov and Sofya Tkachenko</p></td>
</tr><tr> <th>10:40-11:00</th> <td>  </td>
<td> <p className="table-id"> No. #8669</p>
 <p className="table-title">Stock Trend Prediction Based on Complex Network and Sentiment Analysis</p>
 <p className="table-authors">Maoguang Wang and Jiabei He</p></td>
<td> <p className="table-id"> No. #2253</p>
 <p className="table-title">Short Text Topic Modeling with Vector Quantization</p>
 <p className="table-authors">Qiumei Hu, Jingwu Xiao, Junting Lu, Xiankui Zhang, Xueyang Liu and Wenhui Hu</p></td>
<td> <p className="table-id"> No. #6573</p>
 <p className="table-title">Optimization Algorithm of Corpse Combustion Process Based on Improved Genetic Algorithm</p>
 <p className="table-authors">Ziyang Xian, Shuocheng Li, Bingjie Li, Yu Mou, Yiping Zhang, Gao Qian and Xueyang Liu</p></td>
</tr><tr> <th>11:00-11:20</th> <td>  </td>
<td> <p className="table-id"> No. #1372</p>
 <p className="table-title">Randomly Synergistic Data Augmentation Based Convolutional Neural Networks for Chinese Herbal Medicine Recognition</p>
 <p className="table-authors">Tao Li, Peiyao Niu, Xiang Fu, Yan Lv, Lumin Zhou, Yifei Li and Baopeng Ye</p></td>
<td> <p className="table-id"> No. #3001</p>
 <p className="table-title">Domain-Specific Information Extraction in Chinese with Pre-Trained Language Models: An Exploration Report</p>
 <p className="table-authors">Shuyang Nie, Fan Li, Wei Wei and Kun Liu</p></td>
<td> <p className="table-id"> No. #3154</p>
 <p className="table-title">Trends and Developments in Online Education Research from a Highly Cited Literature Perspective: A Bibliometric and Visualization Analysis</p>
 <p className="table-authors">Huichan Ren and Suhaila Abdullah</p></td>
</tr><tr> <th>14:30-14:50</th> <td>  </td>
<td> <p className="table-id"> No. #1864</p>
 <p className="table-title">A Graph Neural Network Approach for Early Plant Disease Detection</p>
 <p className="table-authors">Kafui Kenneth Henoc Bossoun and Xu Ying</p></td>
<td> <p className="table-id"> No. #7235</p>
 <p className="table-title">Privacy-Preserving Federated Learning Scheme for Power Loads Forecasting</p>
 <p className="table-authors">Rui Wang, Xin Liu, Yingxian Chang, Donglan Liu, Bing Liu, Lei Ma, Hao Zhang, Honglei Yao, Fangzhe Zhang, Lili Sun and Bing Su</p></td>
<td> <p className="table-id"> No. #8736</p>
 <p className="table-title">Contextual State Pattern Determination-Based Heuristic Program Synthesis</p>
 <p className="table-authors">Hao Pan, Quansheng Dou, Huixian Wang and Shun Zhang</p></td>
</tr><tr> <th>14:50-15:10</th> <td>  </td>
<td> <p className="table-id"> No. #7075</p>
 <p className="table-title">Attention-based Early and Late Fusion of Audio Visual for Deepfake Detection</p>
 <p className="table-authors">Surbhi Raj, Jimson Mathew and Arijit Mondal</p></td>
<td> <p className="table-id"> No. #3543</p>
 <p className="table-title">Enterprise Credit Risk Assessment Based on Rotate Forest Feature Transformation and Heterogeneous Ensemble Learning</p>
 <p className="table-authors">Maoguang Wang and Jiabei He</p></td>
<td> <p className="table-id"> No. #9330</p>
 <p className="table-title">Iteratively Measuring Capital Liberalization in Stationary State on PageRank</p>
 <p className="table-authors">Haitao Duan, Muquan Zou, Vanha Tran, Shuangfeng Li and Jiankun Yang</p></td>
</tr><tr> <th>15:10-15:30</th> <td>  </td>
<td> <p className="table-id"> No. #8663</p>
 <p className="table-title">Underwater Multi-objective Detection by Using Swin Transformer Based YOLO Network</p>
 <p className="table-authors">Weilin Luo, Chengyu Lin and Huan Zhou</p></td>
<td> <p className="table-id"> No. #9265</p>
 <p className="table-title">Probabilistic ε-greedy Strategy for Exploitation in Homogeneous Multi-agent Reinforcement Learning</p>
 <p className="table-authors">Shanqi Li, Xiangrui Meng, Junqi Zhang, Shaoqiu Zheng, Yi Zuo, Shixin Zheng and Ying Tan</p></td>
<td> <p className="table-id"> No. #221</p>
 <p className="table-title">Global and Local Enhanced Crow Search Algorithm for Weapon Target Assignment</p>
 <p className="table-authors">Yi Liu, Yangsen Zhou, Wei Wei, Qing Li, Qibin Zheng, Kun Liu and Guoli Yang</p></td>
</tr><tr> <th>15:30-15:50</th> <td>  </td>
<td> <p className="table-id"> No. #6819</p>
 <p className="table-title">Small Object Detection Algorithm in Aerial Images Based on Multi-Level Feature Fusion</p>
 <p className="table-authors">Bo Wang, Quansheng Dou, Haoxu Ma and Yue Kong</p></td>
<td> <p className="table-id"> No. #6051</p>
 <p className="table-title">AdaBoost Integration Framework Based on Multiple Filters</p>
 <p className="table-authors">Xiaoqian Xie and Xiaobo Li</p></td>
<td> <p className="table-id"> No. #6385</p>
 <p className="table-title">Med-RAIK: Interpretable Medication Recommendation Model Augmented by Integrating Knowledge Graph</p>
 <p className="table-authors">Huicong Wei, Shugeng Zhou and Chi Zhang</p></td>
</tr><tr> <th>16:10-16:30</th> <td>  </td>
<td> <p className="table-id"> No. #420</p>
 <p className="table-title">Distribution Adaptive-based Defect Detection Prior to Ship Hull Welding</p>
 <p className="table-authors">Haoxu Ma, Quansheng Dou, Yue Kong and Bo Wang</p></td>
<td> <p className="table-id"> No. #3026</p>
 <p className="table-title">From Big Data to Smart Data: Effective Subset Generation for Machine Learning Model Training</p>
 <p className="table-authors">Hanxiao Sun, Tao Zhang, Xin Zhao, Yanzhang Geng, Yang Wang and Ming Yang</p></td>
<td> <p className="table-id"> No. #8408</p>
 <p className="table-title">Research on the Implementation Mechanism of Dynamic Ontology in Knowledge Graph</p>
 <p className="table-authors">Yu Wen, Yiting Shi, Qidong Sun, Xueyang Liu and Wenhui Hu</p></td>
</tr><tr> <th>16:30-16:50</th> <td>  </td>
<td> <p className="table-id"> No. #3710</p>
 <p className="table-title">Wildfire Smoke Detection based on Motion Aware and Feature Enhancement</p>
 <p className="table-authors">Yuhui Geng, Junhao Wang, Dashuai Yu and Peng Yang</p></td>
<td> <p className="table-id"> No. #1685</p>
 <p className="table-title">A Geographical Location Mining Model for Users on Social Media Platforms</p>
 <p className="table-authors">Qiumei Hu, Junting Lu, Haoxuan Wang, Jingwu Xiao, Wenhui Hu and Xueyang Liu</p></td>
<td> <p className="table-id"> No. #4301</p>
 <p className="table-title">Decomposition and Generation Method of Task Data Requirement List Based on Graph Model</p>
 <p className="table-authors">Hong Yan, Zhenya Li, Jing Wang, Shaoqiu Zheng and Yu Zhou</p></td>
</tr><tr> <th>16:50-17:10</th> <td>  </td>
<td> <p className="table-id"> No. #8769</p>
 <p className="table-title">UNet++ cell segmentation and counting algorithm based on morphology and convex hull defect detection</p>
 <p className="table-authors">Junfeng Chen, Yuzhu Liu, Mengzhao Yao and Jingjing Du</p></td>
<td> <p className="table-id"> No. #7478</p>
 <p className="table-title">RAGtag: A Retrieval-Augmented Generation-Based Topic Modeling Framework</p>
 <p className="table-authors">Zhuofan Shi, Shuyang Nie, Shiqi Ning, Fan Li, Kun Liu and Tong Huo</p></td>
<td> <p className="table-id"> No. #2741</p>
 <p className="table-title">QuatRE: Knowledge Graph Embeddings via Relation Rotation in Quaternion Space</p>
 <p className="table-authors">Jiefei Jin and Xiaobo Li</p></td>
</tr><tr> <th>17:10-17:30</th> <td>  </td>
<td> <p className="table-id"> No. #7301</p>
 <p className="table-title">Large Language Model-based Automatic Generation Method for Test Cases Across Multiple Programming Language Types</p>
 <p className="table-authors">Shuyi Li, Yiting Shi, Hanlin Xue, Xueyang Liu and Wenhui Hu</p></td>
<td> <p className="table-id"> No. #7995</p>
 <p className="table-title">Granular-ball Computing based Fireworks Algorithm for Global Optimization of Multi-modal Functions</p>
 <p className="table-authors">De-Gang Chen, Shuyin Xia, Bin Hou, Xinyu Lin, Sen Zhao and Guoyin Wang</p></td>
<td> <p className="table-id"> No. #4272</p>
 <p className="table-title">Research on the Architecture of Software-Defined Decision-Making Operating System Based on Dynamic Ontology</p>
 <p className="table-authors">Wei Wei, Weiyou Wang, Qinghua Zhou, Xiang Li and Kun Liu</p></td>
</tr></table>
<div className="title-center"><h4>Day II &nbsp;&nbsp;&nbsp;Dec. 15th</h4></div>
<table className="sessions">
<tr> <th> Session Time </th><th>Boardroom(10th floor)</th>
<th>Online Room 1</th>
<th>Online Room 2</th>
<th>Online Room 3</th>
 </tr><tr> <th>10:30-11:00</th> <td> <p className="table-id"> No. #9821</p>
 <p className="table-title">Comparative Analysis of YOLOv8 and DeepLabv3+ on WildScenes Dataset: Evaluating mIoU Performance</p>
 <p className="table-authors">Zhiou Zhang, Kuangran Guo, Minghao Bai, Yanxiu Lyu, Haihui Xu, Weian Guo and Dongyang Li</p></td>
<td>  </td>
<td>  </td>
<td>  </td>
</tr><tr> <th>11:00-11:30</th> <td> <p className="table-id"> No. #5854</p>
 <p className="table-title">An Effective Parameter Tuning Technique for Plain and Scalable Spectral Clustering Methods</p>
 <p className="table-authors">Valen Feldmann, Irene Seo, Eli Edwards-Parker and Guangliang Chen</p></td>
<td>  </td>
<td>  </td>
<td>  </td>
</tr><tr> <th>11:30-12:00</th> <td> <p className="table-id"> No. #3979</p>
 <p className="table-title">Improved DETR for Pedestrian Detection from the perspective of UAV</p>
 <p className="table-authors">Zhengshan Wang, Haoran Jin, Chengyao Xue, Tengchao Zhang and Chen Long</p></td>
<td>  </td>
<td>  </td>
<td>  </td>
</tr><tr> <th>14:30-15:00</th> <td> <p className="table-id"> No. #667</p>
 <p className="table-title">Classification of Agricultural Data using MultiLayer Extreme Learning Machine with Fuzzy Kernel Function</p>
 <p className="table-authors">Avatharam Ganivada</p></td>
<td>  </td>
<td>  </td>
<td>  </td>
</tr><tr> <th>15:00-15:30</th> <td> <p className="table-id"> No. #7973</p>
 <p className="table-title">The Multifaceted Impacts of Government Policy on Pharma Firms Based on Forecasting: Insights from a Case Study on Centralized Drug Procurement in China</p>
 <p className="table-authors">Tingting Liu, Yaqi Zhang, Ben Niu and Huifen Zhong</p></td>
<td>  </td>
<td>  </td>
<td>  </td>
</tr><tr> <th>15:30-16:00</th> <td> <p className="table-id"> No. #5075</p>
 <p className="table-title">A Neural Network Approach for Predicting Crop Import Prices: A Case Study of Qatar</p>
 <p className="table-authors">Raka Jovanovic, Sa&apos;D Shannak and Antonio Sanfilippo</p></td>
<td>  </td>
<td>  </td>
<td>  </td>
</tr><tr> <th>16:30-17:00</th> <td> <p className="table-id"> No. #7385</p>
 <p className="table-title">Hybridizing Earthquake Dynamics-based Optimization with Multiple Adaptative Differential Evolution: Towards a Faster Convergence Metaheuristic</p>
 <p className="table-authors">Siddhi Kumari Sharma, Lavika Goel and Namita Mittal</p></td>
<td>  </td>
<td>  </td>
<td>  </td>
</tr><tr> <th>17:00-17:30</th> <td> <p className="table-id"> No. #9352</p>
 <p className="table-title">A Gaussian Function-Based Masking Method for UAV Target Tracking</p>
 <p className="table-authors">Yang Zhang, Chengyao Xue and Long Chen</p></td>
<td>  </td>
<td>  </td>
<td>  </td>
</tr><tr> <th>17:30-18:00</th> <td> <p className="table-id"> No. #2241</p>
 <p className="table-title">Distractor Generation for Multiple-Choice Question Using Existing Distractor</p>
 <p className="table-authors">Koya Higa, Taisei Watanabe and Kensuke Baba</p></td>
<td>  </td>
<td>  </td>
<td>  </td>
</tr></table>
</div>



          {/* // <h4>The detailed program arrangement will be released later.</h4> */}


          {/* <ProgramTable /> */}


          {/* <div className="entry-content">
						<h4>Preliminary Schedules for ICSI &apos; 2021</h4>
						<p>July 17th 13:00pm-18:00pm(GMT+8): Onsite Registration</p>
						<p>July 17th 18:00pm-19:30pm(GMT+8): Beer Festival (Reception)</p>
					    <p>July 18th 8:30am-12:00am(GMT+8): Opening Ceremony, Plenary Speeches &amp; Invited Talks</p>
					    <p>July 18th, 13:00pm-17:20pm(GMT+8): Parallel Sessions</p>
					    <p>July 18th, 18:00pm-20:00pm(GMT+8): Award Ceremony &amp; Banquet</p>
					    <p>July 19th, 9:00am-12:00am(GMT+8): Parallel Sessions</p>
					    <p>July 18th, 10:20am-10:40am, 15:00pm-15:20pm(GMT+8): Coffee Breaks</p>
					    <p>July 19th, 10:20am-10:40am(GMT+8): Coffee Breaks</p>
					    <p>July 20th &amp; 21st: Post-event Activities &amp; Tour (free activities, self-pay, not officially organized)</p>
                        <br/>
					    <h4>
					        Zoom for all sessions:
					    </h4>

					    <p>
					        Yan Xi Tang 燕喜堂: 847 7347 7938<br/>
					        Bo Hai Hall 渤海厅：847 7347 7938<br/>
					        Nan Hai Hall 南海厅：826 7855 8364<br/>
					        Huang Hai Hall 黄海厅：812 4427 4048<br/>
					        Zoom I: 826 0784 1667<br/>
					        Zoom II: 859 6443 6186
					    </p>
                        <br/>
					     <img src="http://39.98.207.139:8080/icsi2021/wp-content/uploads/new.gif" alt=""
                                    width={28} height={11}/>
                        
					      <a href="/sessions"><b className="timetable">Detailed Scheduled Presentations Timetables!</b></a>
					</div> */}
          <div className="space-40"></div>
          {/* <div className="newfig">

          <h4>Detailed Scheduled Presentations Timetables</h4>
          </div> */}


          {/* <div className="entry-content2">
          <Link
            className="btn btn-primary btn-hover-secondary  mt-s"
            to={process.env.PUBLIC_URL + "/sessions"}
          >
            Sessions
          </Link>


        </div> */}
        </EmptyTwo>
        {/* <AboutFive />
            <TestimonialContainer classOption="bg-primary-blue" />
            <CallToActionTwo /> */}
        <Footer />
        <ScrollToTop />
      </React.Fragment>
    );
  }
  else {
    return (
      <React.Fragment>
        <SEO title="Program | DMBD 2025" />
        <Header />
        <Breadcrumb
          image="images/bg/banner2.jpg"
          title="Program"
          content="The Conference"
          contentTwo="Program"
          linkage="/"
        />

        {/* <HomeAbout /> */}
        <EmptyTwo>
          <div>
            <h4>To be released.</h4>
          </div>
        </EmptyTwo>
        {/* <AboutFive />
              <TestimonialContainer classOption="bg-primary-blue" />
              <CallToActionTwo /> */}
        <Footer />
        <ScrollToTop />
      </React.Fragment>
    )
  }
};

export default Program;
